'use strict';

export function ScrollTop() {
  document.querySelector('.js-scroll-top').addEventListener('click', () => {
    window.scrollTo(0, 0);
  });
}